<template>
  <div class="issu-modal">
    <button
      class="issu-modal__close icon-button"
      type="button"
      @click.prevent="overlay.close()"
    >
      <span
        class="visually-hidden"
        v-text="$string('accessibility.close')"
      />

      <icon-close />
    </button>

    <iframe
      :src="`https://e.issuu.com/embed.html?d=${issuName}&hideIssuuLogo=true&hideShareButton=true&u=collinsed`"
      frameborder="0"
      height="100%"
      width="100%"
    />
  </div>
</template>

<script>

/**
 * Vue: Product gallery modal (product-gallery-modal)
 * -----------------------------------------------------------------------------
 * Fullscreen product gallery modal with zoom.
 *
 * @param {Object} [overlay] - Overlay API.
 * @param {String} issuName - Issu document name.
 */
import { mapActions } from 'vuex'

import IconClose from '~icons/directional-navigation/close.svg'

export default {
  name: 'IssuModal',

  components: {
    IconClose,
  },

  props: {
    overlay: {
      type: Object,
      default: () => ({}),
    },
    issuName: {
      type: String,
      required: true,
    },
  },

  computed: {

    /**
     * Compute media array.
     * @returns {Array}
     */
    media() {
      return !this.product?.media && this.product?.images
        ? this.product.images || []
        : this.product.media || []
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      closeOverlay: 'overlays/close',
    }),

    /**
     * Handle Splide mounted to trap focus in overlay.
     */
    async handleSplideMounted() {
      await cnvs.Sleep(500)
    },
  },
}
</script>

<style lang="scss">
@import './issu-modal';
</style>
